import { render } from "./AddTypeFretPaiePage.vue?vue&type=template&id=279c4344&ts=true"
import script from "./AddTypeFretPaiePage.vue?vue&type=script&lang=ts"
export * from "./AddTypeFretPaiePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__